// extracted by mini-css-extract-plugin
export default {"popper":"styles_popper__tfVKq","popperBody":"styles_popperBody__SxgRh","frequency":"styles_frequency__p4oJS"};